const searchErrorConfig = {
    insufficient_scope: {
        pattern: /insufficient_scope/i,
        message: 'User has insufficient permissions to perform the requested action.',
    },
    network_error: {
        pattern: /request:? error|network error/i,
        message: 'Network error.  Please check your connection and try again.',
    },
    no_best_matches: {
        pattern: 'No best matches',
        message: 'No mapping matches were found for the selected media item.',
    },
    no_matching_criteria: {
        pattern: /No .* matching criteria/i,
        message: 'No matching items found.', // 'Please check your search criteria and try again.'
    },
    query_syntax: {
        pattern: /Invalid query syntax detected/i,
        message: 'An invalid value was entered into a search field.  Please check your search criteria and try again.',
    },
    refresh_token_invalid: {
        pattern: /Invalid refresh token:/i,
        message: 'Session has timed out.',
    },
    refresh_token_expired: {
        pattern: /Invalid refresh token [(]/i,
        message: 'Session refresh token has expired.',
    },
    service_error: {
        pattern: /not found/i,
        message: 'Service unavailable.  Please check your connection and try again later.',
    },
    server_error_shards: {
        pattern: /(all shards failed|failed to map source)/i,
        message:
            'We are currently experiencing problems with this request.  Please try again later or report this issue including error details and steps to reproduce.',
    },
    service_unavailable: {
        pattern: /(service unavailable|status:? code 503|bad gateway)/i,
        message: 'Service unavailable.  The back-end server may be undergoing maintenance.',
    },
    submit_error: {
        pattern: /(Could not read document|Can not deserialize value)/i,
        message: 'An error occurred when submitting data to the server.  Please check the form values and try again.',
    },
    unauthorized: {
        pattern: /Bad credentials|Unauthorized/i,
        message: 'Invalid username or password.  Please try again.',
    },
    unknown_error: {
        pattern: /unknown error/i,
        message: 'An unknown error has occurred.  Please check your connection and try again.',
    },
};

export default searchErrorConfig;
